export const useEnvPaths = () => {
  const config = useRuntimeConfig();

  const getZenApiUrl = () => {
    return config.public.zenApi;
  };

  const getCustomApiUrl = () => {
    return config.public.customApiUrl;
  };

  const getAnalyticsUrl = () => {
    return config.public.analyticsUrl;
  };

  const getGAIds = () => {
    const path = config.public.gaTagIds as string;
    return path.split(',');
  };

  const appName = () => {
    return config.public.appName;
  };

  return {
    getZenApiUrl,
    getCustomApiUrl,
    getAnalyticsUrl,
    getGAIds,
    appName,
  };
};
